.user {
  padding: var(--mantine-spacing-xs);
  border-radius: var(--mantine-radius-sm);
  transition: background-color 150ms ease;
  cursor: pointer;
  
  &:hover {
    background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6));
  }
  
  &:active {
    transform: translateY(1px);
  }
}